import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import TimerIcon from '@material-ui/icons/Timer';
import { withStyles } from '@material-ui/core/styles';
import { useRecoilValue } from 'recoil';

import styles from '../../theme/styles';
import { holdCountdownState } from '../../common/recoil/atom/HoldCountdownAtom';
import {
  formatTimeRemaining,
  WARNING_THRESHOLD_SECONDS,
} from '../../hooks/useHoldCountdown';

// Display-only: the tick, announcements and expiry live in useHoldCountdown.
// role="timer" is not a live region, so the changing label is never announced.
const HoldTimer = ({ classes }) => {
  const hold = useRecoilValue(holdCountdownState);
  if (!hold) return null;

  const { minutes, seconds } = hold;
  const total = minutes * 60 + seconds;
  const isWarning = total > 0 && total <= WARNING_THRESHOLD_SECONDS;
  const clock = `${minutes}:${String(seconds).padStart(2, '0')}`;

  return (
    <Typography
      component="div"
      variant="body2"
      role="timer"
      aria-label={`Appointment hold: ${formatTimeRemaining(minutes, seconds)}`}
      className={classNames(classes.holdTimer, {
        [classes.holdTimerWarning]: isWarning,
      })}
    >
      <TimerIcon className={classes.holdTimerIcon} aria-hidden="true" />
      <span className={classes.holdTimerClock} aria-hidden="true">
        {clock}
      </span>
    </Typography>
  );
};

HoldTimer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HoldTimer);
